<template>
	<div>
		<i class="fa fa-spinner fa-pulse fa-lg fa-fw" v-if="loading"></i>
	</div>

</template>


<script>

	export default {
		name: 'LoadingSpinner',
		data () {
			return {

			}
		},

		props: {

			loading: {
				required: true,
				type: Boolean
			}
		},

		methods: {

		},

		computed: {

		},

		mounted: function() {

		}

}
</script>



<style scoped>
	
</style>








